var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-table"},[_c('table',_vm._l((_vm.content.Rows),function(row,rowIndex){return _c('tr',{key:rowIndex},_vm._l((Object.keys(row)),function(rowKey,index){return _c('td',{key:index,domProps:{"innerHTML":_vm._s(row[rowKey])}})}),0)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }